import React, {Component} from 'react';


import s from './Footer.module.css';

class Footer extends Component {
    constructor() {
        super();
        this.state = {
            name: '',
            email: '',
            phone: '',
            message: '',
            loading: false
        };
    }

    handleContactFormChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    handleSubmitContactForm = (e) => {
        e.preventDefault()
        const url = new URL(`${process.env.REACT_APP_APP_URL}/api/contact`);
        const to = process.env.REACT_APP_CONTACT_FORM_EMAIL

        this.setState({
            loading: true
        }, () => {
            fetch(url, {
                headers: new Headers({
                    'Authorization': `Bearer ${process.env.REACT_APP_TOKEN}`,
                    'Content-Type':'application/json'
                }),
                method: "POST",
                body: JSON.stringify({
                    "email" : this.state.email,
                    "phone" : this.state.phone,
                    "name" : this.state.name,
                    "message" : this.state.message,
                    "to" : to
                })
            }).then(res => res.json())
                .then(() => this.setState({
                    name: '',
                    email: '',
                    phone: '',
                    message: '',
                    loading: false
                }))
                .catch(error => console.error('Error:', error));
        })
    }

    handleClick = (e) => {
        e.preventDefault()
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        this.props.handleObjectType(e.target.id)
    }

    render() {

        const address = process.env.REACT_APP_FOOTER_ADDRESS
        const email = process.env.REACT_APP_FOOTER_EMAIL
        const phone = process.env.REACT_APP_FOOTER_PHONES.split(',')
        const socials = JSON.parse(process.env.REACT_APP_FOOTER_SOCIALS)

        return (
            <footer className={s.footer}>
                {/*<p className={s.footer_text}></p>*/}
                <div className={`${s.footer_links} ' footer row align-items-start '`}>
                    <div className={`${s.footer_contacts} ' col-12 col-md-6 col-xl-4 '`}>
                        <div className={`${s.footer_title}`}>
                            Контакты
                        </div>
                        <div className={`${s.footer_address}`}>
                            <p>
                                <svg width="16px" height="16px" viewBox="0 0 16 16" className="bi bi-geo-alt-fill"
                                     fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                          d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                                </svg>
                                Наш адрес
                            </p>
                            <span>{address}</span>
                        </div>
                        <div className={`${s.footer_phone}`}>
                            <div className={`${s.footer_phone_title}`}>
                                <svg width="16" height="16" viewBox="0 0 33 33" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0)">
                                        <path
                                            d="M27.3767 20.4417C26.7011 19.7383 25.8862 19.3622 25.0226 19.3622C24.1659 19.3622 23.3441 19.7313 22.6406 20.4348L20.4397 22.6287C20.2586 22.5312 20.0775 22.4407 19.9034 22.3501C19.6527 22.2248 19.4159 22.1063 19.2139 21.981C17.1523 20.6716 15.2787 18.9652 13.4818 16.7573C12.6112 15.6569 12.0261 14.7305 11.6013 13.7903C12.1724 13.2679 12.7017 12.7247 13.2171 12.2023C13.4121 12.0073 13.6072 11.8053 13.8022 11.6103C15.2648 10.1477 15.2648 8.25321 13.8022 6.79058L11.9008 4.88917C11.6848 4.67326 11.462 4.45038 11.253 4.22751C10.8351 3.79569 10.3963 3.34993 9.94363 2.93204C9.26804 2.26341 8.46011 1.9082 7.6104 1.9082C6.76068 1.9082 5.93883 2.26341 5.24234 2.93204C5.23537 2.939 5.23537 2.939 5.22841 2.94597L2.86035 5.33492C1.96885 6.22643 1.46041 7.31295 1.34897 8.57359C1.18181 10.6073 1.78079 12.5018 2.24048 13.7415C3.36879 16.7852 5.05429 19.606 7.56861 22.6287C10.6192 26.2713 14.2897 29.1478 18.4826 31.1746C20.0845 31.9338 22.2227 32.8323 24.6117 32.9855C24.7579 32.9924 24.9111 32.9994 25.0504 32.9994C26.6593 32.9994 28.0105 32.4213 29.0692 31.2721C29.0761 31.2582 29.0901 31.2512 29.097 31.2373C29.4592 30.7985 29.8771 30.4015 30.3159 29.9767C30.6154 29.6911 30.9218 29.3916 31.2213 29.0782C31.9109 28.3608 32.273 27.525 32.273 26.6683C32.273 25.8047 31.9039 24.9759 31.2004 24.2794L27.3767 20.4417ZM29.8701 27.7758C29.8632 27.7758 29.8632 27.7827 29.8701 27.7758C29.5985 28.0683 29.3199 28.3329 29.0204 28.6255C28.5677 29.0573 28.108 29.51 27.6762 30.0184C26.9728 30.7707 26.1439 31.1259 25.0574 31.1259C24.9529 31.1259 24.8415 31.1259 24.737 31.1189C22.6685 30.9866 20.7462 30.1786 19.3044 29.4891C15.3623 27.5807 11.9008 24.8714 9.02427 21.4377C6.64924 18.5752 5.06125 15.9285 4.00955 13.0868C3.36182 11.3526 3.12502 10.0014 3.22949 8.72682C3.29914 7.91193 3.61256 7.23633 4.19064 6.65825L6.56566 4.28323C6.90694 3.96284 7.26912 3.78872 7.62433 3.78872C8.06311 3.78872 8.41832 4.05339 8.6412 4.27626C8.64816 4.28323 8.65513 4.29019 8.66209 4.29716C9.08695 4.69415 9.49091 5.10508 9.91577 5.54387C10.1317 5.76675 10.3546 5.98962 10.5774 6.21946L12.4788 8.12087C13.2171 8.85915 13.2171 9.54171 12.4788 10.28C12.2769 10.482 12.0818 10.6839 11.8799 10.879C11.2948 11.4779 10.7376 12.0351 10.1317 12.5784C10.1178 12.5923 10.1038 12.5993 10.0969 12.6132C9.49788 13.2122 9.60932 13.7972 9.73468 14.1942C9.74165 14.2151 9.74861 14.236 9.75558 14.2569C10.2501 15.4549 10.9466 16.5832 12.0052 17.9274L12.0122 17.9344C13.9345 20.3024 15.9613 22.1481 18.197 23.562C18.4826 23.7431 18.7751 23.8894 19.0537 24.0287C19.3044 24.154 19.5412 24.2724 19.7432 24.3978C19.7711 24.4117 19.7989 24.4326 19.8268 24.4465C20.0636 24.5649 20.2865 24.6207 20.5163 24.6207C21.0944 24.6207 21.4566 24.2585 21.575 24.1401L23.957 21.7581C24.1938 21.5213 24.5699 21.2357 25.0087 21.2357C25.4405 21.2357 25.7957 21.5074 26.0116 21.7442C26.0186 21.7511 26.0186 21.7511 26.0255 21.7581L29.8632 25.5958C30.5806 26.3062 30.5806 27.0375 29.8701 27.7758Z"
                                            fill="white"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0">
                                            <rect width="33" height="33" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                Телефоны
                            </div>
                            <div className={`${s.footer_phone_number}`}>
                                {phone.map(item =>
                                    <a href={`tel:${item}`}>
                                        {item}
                                    </a>
                                )}
                            </div>
                        </div>
                        <div className={`${s.footer_email}`}>
                            <p>
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                     width="16px" height="18px" viewBox="0 0 485.211 485.211">
                                    <g>
                                        <path d="M485.211,363.906c0,10.637-2.992,20.498-7.785,29.174L324.225,221.67l151.54-132.584
		                                        c5.895,9.355,9.446,20.344,9.446,32.219V363.906z M242.606,252.793l210.863-184.5c-8.653-4.737-18.397-7.642-28.908-7.642H60.651
		                                        c-10.524,0-20.271,2.905-28.889,7.642L242.606,252.793z M301.393,241.631l-48.809,42.734c-2.855,2.487-6.41,3.729-9.978,3.729
		                                        c-3.57,0-7.125-1.242-9.98-3.729l-48.82-42.736L28.667,415.23c9.299,5.834,20.197,9.329,31.983,9.329h363.911
		                                        c11.784,0,22.687-3.495,31.983-9.329L301.393,241.631z M9.448,89.085C3.554,98.44,0,109.429,0,121.305v242.602
		                                        c0,10.637,2.978,20.498,7.789,29.174l153.183-171.44L9.448,89.085z"/>
                                    </g>
                                </svg>
                                Наш e-mail
                            </p>
                            <a href={`mailto:${email}`}>
                                {email}
                            </a>
                        </div>
                        <div className={`${s.footer_social}`}>
                            {socials.facebook !== undefined ? (
                                <a href={`${socials.facebook}`}>
                                    <svg enable-background="new 0 0 128 128" id="Social_Icons" version="1.1" viewBox="0 0 128 128"
                                         xmlns="http://www.w3.org/2000/svg"><g id="_x31__stroke"><g id="Facebook_1_"><rect fill="none" height="128" width="128"/><path
                                        clip-rule="evenodd"
                                        d="M68.369,128H7.065C3.162,128,0,124.836,0,120.935    V7.065C0,3.162,3.162,0,7.065,0h113.871C124.837,0,128,3.162,128,7.065v113.87c0,3.902-3.163,7.065-7.064,7.065H88.318V78.431    h16.638l2.491-19.318H88.318V46.78c0-5.593,1.553-9.404,9.573-9.404l10.229-0.004V20.094c-1.769-0.235-7.841-0.761-14.906-0.761    c-14.749,0-24.846,9.003-24.846,25.535v14.246H51.688v19.318h16.681V128z"
                                        fill-rule="evenodd" id="Facebook"/></g></g></svg>
                                </a>
                            ) : null}
                            {socials.twitter !== undefined ? (
                                <a href={`${socials.twitter}`}>
                                    <svg enable-background="new 0 0 512 512" id="Layer_1" version="1.1" viewBox="0 0 512 512"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <g>
                                            <path d="M3.5,421.4c56,5.1,106.1-8.9,151.5-42.9c-7-1.6-13.4-1.6-19.5-3.1c-35.7-8.5-60.4-30-74.9-63.5   c-0.7-1.7-2.5-3.8-0.9-5.5c1.2-1.3,3.5-0.2,5.2,0c12.6,1.3,25.2,0.9,37.6-2c0.2-2.2-1.4-2-2.6-2.4c-30.7-8.2-53-26.5-67.4-54.8   c-6.6-13-10.2-26.6-10.6-41.2c-0.2-5.7,0.1-5.8,5.4-3.3c12.6,6,25.8,9.4,40.9,10.1c-6.9-5.6-13.1-10.5-18.4-16.4   c-16.1-17.9-25.1-38.8-27-62.9c-1.5-19.6,2.6-37.9,11.1-55.5c1.9-3.9,3.6-3.6,6-0.7C56.6,97.7,76.1,115,97.6,130   c16,11.2,33,20.5,50.9,28.4c23.6,10.3,48.1,17.2,73.5,21.3c8,1.3,16.2,1.6,24.3,2.4c4.1,0.4,5.2-0.8,4.4-5   c-4.1-21.6-1.3-42.6,8.1-62.3c16.1-33.6,43.1-54,79.8-59.4c32.6-4.8,61.9,4.5,86.2,27.4c3.7,3.5,7,4.4,12,3.1   c19.6-5,38.3-12.1,55.9-22.1c0.5-0.3,1.1-0.4,2.9-1.1c-8.2,24.1-22.7,41.9-43,55.5c4.7,0.9,18.6-1.6,28.2-4.6   c9.2-2.9,18.4-5.5,27.2-9.4c1.2,1.3,0.1,2-0.4,2.7c-11.7,16.5-25.1,31.4-41.1,43.8c-2.2,1.7-4.3,3.6-6.6,5.2   c-1.7,1.2-1.8,2.7-1.7,4.4c0.7,18.2-0.6,36.3-3.2,54.2c-2.7,18.3-7.3,36.1-13.4,53.6c-5,14.3-10.9,28.2-17.9,41.7   c-17.3,33.2-39.8,62.4-67.9,87.3c-29.9,26.4-63.9,45.4-101.9,57.2c-23.7,7.4-48,11.7-72.9,13c-19.2,1-38.3,0.7-57.3-1.7   c-27.2-3.3-53.4-10.7-78.6-21.5c-12.9-5.5-25.1-12.1-37.3-19C6.1,424.4,4.4,423.6,3.5,421.4z"
                                            />
                                        </g>
                                    </svg>
                                </a>
                            ) : null}
                            {socials.instagram !== undefined ? (
                                <a href={`${socials.instagram}`}>
                                    <svg enable-background="new 0 0 512 512" id="Layer_1" version="1.1" viewBox="0 0 512 512"
                                         xmlns="http://www.w3.org/2000/svg" ><g><path d="M505,257c0,34.8-0.7,69.7,0.2,104.5c1.5,61.6-37.2,109.2-86.5,130.4c-19.8,8.5-40.6,13-62.1,13c-67.3,0.1-134.7,1-202-0.3   c-50.7-1-92.4-22.2-122.3-64c-15.7-22-23.2-47-23.2-74.1c0-71.7,0-143.3,0-215c0-58.5,28.5-99.4,79.1-126C110.2,14,134.1,9.1,159,9   c65.3,0,130.7-0.4,196,0.2c50.7,0.4,93,19.8,124.2,60.6c17.4,22.8,25.8,49,25.8,77.8C505,184,505,220.5,505,257z M46,257   c0,36.7,0,73.3,0,110c0,16.4,3.8,31.8,12.3,45.7c22.3,36.5,56,54.3,97.8,55c67.1,1,134.3,0.4,201.5,0.2c16.5,0,32.5-3.4,47.4-10.5   c40.6-19.4,63.3-50.3,63.1-96.7c-0.4-71-0.1-142-0.1-213c0-20.1-5.7-38.5-17.6-54.7c-23-31.1-54.8-46.4-92.8-46.8   c-67-0.8-134-0.3-201-0.2c-14.3,0-28.1,2.9-41.5,7.9c-36.8,13.7-71,48.4-69.4,99.5C46.9,188,46,222.5,46,257z"/><path
                                        d="M257.6,363c-64.5,0-116.5-51.4-116.6-115.4c-0.1-63,52.3-114.6,116.4-114.6c64.3-0.1,116.5,51.4,116.6,114.9   C374,311.3,321.9,362.9,257.6,363z M257.6,326c43.9,0,79.5-35.1,79.4-78.3c-0.1-42.8-35.7-77.8-79.4-77.8   c-43.9,0-79.7,34.9-79.7,78C178,291.1,213.7,326.1,257.6,326z"/><path
                                        d="M387.5,98c13.5,0,24.5,11.5,24.5,25.6c-0.1,14.1-11.2,25.5-24.7,25.4c-13.3-0.1-24.2-11.5-24.2-25.3   C363,109.6,374,98,387.5,98z"/></g></svg>
                                </a>
                            ) : null}
                            {socials.telegram !== undefined ? (
                                <a href={`${socials.telegram}`}>
                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="mdi-telegram"
                                         width="24" height="24" viewBox="0 0 24 24">
                                        <path d="M9.78,18.65L10.06,14.42L17.74,7.5C18.08,7.19 17.67,7.04 17.22,7.31L7.74,13.3L3.64,12C2.76,11.75 2.75,11.14 3.84,10.7L19.81,4.54C20.54,4.21 21.24,4.72 20.96,5.84L18.24,18.65C18.05,19.56 17.5,19.78 16.74,19.36L12.6,16.3L10.61,18.23C10.38,18.46 10.19,18.65 9.78,18.65Z"/>
                                    </svg>
                                </a>
                            ) : null}
                        </div>
                    </div>
                    <div className={`${s.footer_contacts} ' col-12 col-md-6 col-xl-4 '`}>
                        <div className={`${s.footer_title}`}>
                            Полезные ссылки
                        </div>
                        <div className={`${s.footer_useful_links}`}>
                            <ul>
                                <li>
                                    <a onClick={e => this.handleClick(e)} id="flat">
                                        Квартиры
                                    </a>
                                </li>
                                <li>
                                    <a onClick={e => this.handleClick(e)} id="private-house">
                                        Частные дома
                                    </a>
                                </li>
                                <li>
                                    <a onClick={e => this.handleClick(e)} id="land">
                                        Земельные участки
                                    </a>
                                </li>
                                <li>
                                    <a onClick={e => this.handleClick(e)} id="commerce">
                                        Комерция
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className={`${s.footer_contacts} ' col-12 col-md-6 col-xl-3 '`}>

                        <div className={`${s.footer_title}`}>
                            Отправить сообщение
                        </div>
                        <div
                            className={`lds_ring ${!this.state.loading ? `custom_hidden` : '' }`}
                        >
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                        <form className={`${s.footer_form}`} onSubmit={this.handleSubmitContactForm}>
                            <label className={`${s.footer_label}`} htmlFor="">
                                Имя
                                <input value={this.state.name} onChange={this.handleContactFormChange} id="name" type="text" placeholder="Имя" required/>
                            </label>
                            <label className={`${s.footer_label}`} htmlFor="">
                                Телефон
                                <input value={this.state.phone} onChange={this.handleContactFormChange} id="phone" type="text" placeholder="Телефон" required/>
                            </label>
                            <label className={`${s.footer_label}`} htmlFor="">
                                email
                                <input value={this.state.email} onChange={this.handleContactFormChange} id="email" type="email" placeholder="email" required/>
                            </label>
                            <textarea value={this.state.message} onChange={this.handleContactFormChange} id="message" placeholder="Сообщение"/>
                            <button type="submit">
                                Отправить >
                            </button>
                        </form>
                    </div>
                </div>
            </footer>
        );
    }

}

export default Footer;
